import { convertToNumber, convertToString } from "@/utils/converts";
import { checkStringIsValid } from "@/utils/validations";

export default {
  state: {
    judicialDecision: {},
    selectedProcedure: {},
    judicialDecisionFilters: {},
  },

  getters: {
    getJudicialDecision: (state) => state.judicialDecision,
    getSeletectedProcedureInJudicialDecision: (state) =>
      state.selectedProcedure,
    getJudicialDecisionFilters: (state) => state.judicialDecisionFilters,
  },

  mutations: {
    setJudicialDecision(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      state.judicialDecision = {
        id: isUpdate ? data.id : "",
        process_number: isUpdate ? data.process_number : "",
        stick: isUpdate ? data.stick : "",
        object: isUpdate ? data.object : "",
        flag_fatal_deadline: isUpdate
          ? checkStringIsValid(data.fatal_deadline)
          : false,
        fatal_deadline: isUpdate ? data.fatal_deadline : "",
        flag_amount: isUpdate ? checkStringIsValid(data.amount) : false,
        amount: isUpdate ? data.amount : null,
        startAmount: isUpdate ? data.amount : null,
        decision_device: isUpdate ? convertToString(data.decision_device) : "",
        alert_message: isUpdate ? convertToString(data.alert_message) : "",
        specific_procedures: isUpdate ? data.specific_procedures : [],
        patients: isUpdate ? data.patients : [],
        solicitations: isUpdate ? data.solicitation : [],
        file_attached: isUpdate ? data.attached_model : [],
        isUpdate,
      };
    },

    setSeletectedProcedureInJudicialDecision(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      state.selectedProcedure = {
        procedure_type_id: isUpdate
          ? convertToNumber(data.procedure_type_id)
          : null,
        co_procedure: isUpdate ? data.co_procedure : null,
        group_procedure_id: isUpdate
          ? convertToNumber(data.group_procedure_id)
          : null,
        co_occupation: isUpdate ? data.co_occupation : null,
        co_sub_occupation: isUpdate ? data.co_sub_occupation : null,
        diagnostic_id: isUpdate ? data.diagnostic_id : null,
      };
    },

    setJudicialDecisionFilter(state, filters) {
      state.judicialDecisionFilters = filters;
    },
  },

  actions: {
    changeJudicialDecision(context, data) {
      context.commit("setJudicialDecision", data);
    },

    changeSeletectedProcedureInJudicialDecision(context, procedure) {
      context.commit("setSeletectedProcedureInJudicialDecision", procedure);
    },

    changeJudicialDecisionFilters(context, filters) {
      context.commit("setJudicialDecisionFilter", filters);
    },
  },
};
